<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  {{data.message}}
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton mat-dialog-close>Cancel</button>
  <button matButton mat-dialog-close="confirmed" cdkFocusInitial>Ok</button>
</mat-dialog-actions>